import React from "react"
import ReactDOM from "react-dom/client"

import { ToastContainer } from "react-bootstrap"
import Toast from "./ToastExtended"

export class ToastManager {

    toasts = []
    container = undefined

    constructor() {

        if(!document.getElementById("meganos-toast-container")) {
            const body = document.getElementsByTagName("body")[0]
            const toastContainer = document.createElement("div")
            toastContainer.id = "meganos-toast-container"
            
            body.insertAdjacentElement("beforeend", toastContainer)
            this.container = ReactDOM.createRoot(document.getElementById("meganos-toast-container"))
        }
    }

    show(options) {
        const toastId = Math.random().toString(36).substring(2, 9)
        const toast = {
            id: toastId,
            ...options, // if id is passed within options, it will overwrite the auto-generated one
            destroy: () => this.destroy(options.id ?? toastId),
        }

        this.toasts = [toast, ...this.toasts]
        this.render()
    }

    destroy(id) {
        this.toasts = this.toasts.filter((toast) => toast.id !== id)
        this.render()
    }

    render() {
        const toastsList = (
            <ToastContainer position="top-end" className="p-3 toast-container-overlay">
                {this.toasts.map((toastProps) => (
                    <Toast key={toastProps.id} {...toastProps} />
                ))}
            </ToastContainer>
        )

        this.container?.render(toastsList)
    }
}

export const toast = new ToastManager()
